import React from 'react';
import TableStep2 from 'Components/Page/Campaign/RegisterCampaign/Common/TableStep2';
import { Prize } from 'Types/Page/Campaign/RegisterCampaign';

import {
  columnId,
  columnInfo,
  columnIsIncentive,
  columnName,
  columnType,
  columnUserQuantity,
  columnWinRate,
} from './ColumnPrizes';

const PrizesTable = ({
  dataSource,
  overCapacityMessage,
  errors,
  showWinRate = false,
}: {
  dataSource: Prize[];
  titleName: string;
  overCapacityMessage?: string;
  errors?: any;
  showWinRate?: boolean;
}): JSX.Element => {
  const headerTables1 = [
    {
      columns: [
        columnId,
        columnName,
        columnType,
        columnUserQuantity,
        columnWinRate(errors),
        columnIsIncentive,
        columnInfo(errors, overCapacityMessage),
      ],
    },
  ];

  const headerTables2 = [
    {
      columns: [
        columnId,
        columnName,
        columnType,
        columnUserQuantity,
        columnIsIncentive,
        columnInfo(errors, overCapacityMessage),
      ],
    },
  ];
  return (
    <div>
      <TableStep2
        headerTables={showWinRate ? headerTables1 : headerTables2}
        dataSource={dataSource}
      />
    </div>
  );
};

export default PrizesTable;
